import { limit } from "./str_limit";
import { lessMore } from "./text_less_more";
import { highlight } from "./highlight";

export default {
    install: (app, options) => {
        app.directive("limit", limit);
        app.directive("lessMore", lessMore);
        app.directive("highlight", highlight);
    },
};
